module.exports = __webpack_public_path__ + "img/abba_nopro_septembre_2_2021.e689ba72.jpg";